export enum ProjectSubjectStatusEnum {
  READY = "READY",
  DRAFT = "DRAFT",
  DEPRECATED = "DEPRECATED",
  TO_REVIEW = "TO_REVIEW",
}
